import { render, staticRenderFns } from "./ConcludeProjectIssue.vue?vue&type=template&id=4c12503a&scoped=true&"
import script from "./ConcludeProjectIssue.vue?vue&type=script&lang=js&"
export * from "./ConcludeProjectIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c12503a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
